import { useCallback, useState } from "react";
import { Container } from "reactstrap";
import { Apps, SocialApp } from "../../../constants";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import ProfileHeader from "./profileHeader";
import SocialTabsContent from "./socialTabsContent";

const SocialAppContainer = () => {
  const [activeTab, setActiveTab] = useState(1);
  const callback = useCallback((tab: number) => setActiveTab(tab), []);

  return (
    <>
      <Breadcrumbs mainTitle={SocialApp} parent={Apps} />
      <Container fluid>
        <div className="user-profile social-app-profile">
          <ProfileHeader callback={callback} />
          <SocialTabsContent activeTab={activeTab} />
        </div>
      </Container>
    </>
  );
};

export default SocialAppContainer;
